module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step3-2-p-741de6d33ad05dd1105baa18ddea6d62.gif";